import React from 'react';
import language from './language';
import { getDateFormatDealer } from '../GetDateFormatDealer';
import { formatCurrencyAmount } from '../culture';
import { formatDateOnly } from '../culture';

const validDateRegex = RegExp(
    /(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](18|19|20|21)\d\d/i
);
const validDateRegexCanadianDealer = RegExp(
    /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/

);
export default class BasicPartInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showOverridePartModal: false,
            overrideHeaderText: "Put part on override (comments)"
        };
    }

    createDataTitlePair = (title, data, isDescription) => {
        return (
            <div className="row no-gutters">
                <div className="col-sm-5 align-left">
                    <p className="data-header">{title}:</p>
                </div>
                {isDescription ?
                    <div dangerouslySetInnerHTML={{ __html: data }} className="col-sm-7 align-left" />
                    : <div className="col-sm-7 align-left">
                        {data}
                    </div>
                }
            </div>
        );
    };


    createDataTitlePairForReason = (title, data, isDescription, inventoryFlagFK, makeSkuFlagFK, tooltipFlagReasonReturnable) => {
        return (
            <div className="row no-gutters">
                <div className="col-sm-5 align-left">
                    <p className="data-header">{title}:</p>
                </div>
                {inventoryFlagFK != makeSkuFlagFK && makeSkuFlagFK == 1 && data == 'No' ?
                    <div className="col-sm-7 align-left">
                        {this.props.pageText.no}
                    </div> :
                    inventoryFlagFK != makeSkuFlagFK && makeSkuFlagFK == 1 && data == 'Yes' ?
                        <div className="col-sm-7 align-left help exculsion-text" title={`${tooltipFlagReasonReturnable}`}>
                            {this.props.pageText.no}
                        </div> :
                        inventoryFlagFK == makeSkuFlagFK && makeSkuFlagFK == 1 && data == 'Yes' ?
                            <div className="col-sm-7 align-left help exculsion-text" title={`${tooltipFlagReasonReturnable}`}>
                                {this.props.pageText.yes}
                            </div> :
                            isDescription ?
                                <div dangerouslySetInnerHTML={{ __html: data }} className="col-sm-7 align-left" />
                                : <div className="col-sm-7 align-left">
                                    {data}
                                </div>
                }
            </div>
        );
    };

    callOverride = () => {
        this.props.oncallOverride(true);
    }
    createDataTitlePairForPartNumber = (title, partNumber, makeTitle, active) => {

        const { pageText, ssChain } = this.props;
        const tooltipPartNotInDMS = pageText.tooltipPartNotInDMS.replace("%%MAKE%%", makeTitle);
        const tooltipPartNotInDataFile = pageText.tooltipPartNotInDataFile.replace("%Make%", makeTitle);

        let tooltip = null;
        if (ssChain.length > 0 && ssChain[0].partNumber === partNumber) {
            tooltip = !active && <i className="material-icons help" title={tooltipPartNotInDataFile}>warning</i>
        }
        else if (ssChain.length > 0 && ssChain[0].partNumber !== partNumber) {
            tooltip = !ssChain[0].active && <i className="material-icons help" title={tooltipPartNotInDMS}>warning</i>
        }

        return (
            <div className="row no-gutters">
                <div className="col-sm-5 align-left">
                    <p className="data-header">{title}:</p>
                </div>
                <div className="col-sm-7 align-left">
                    {partNumber}  {tooltip}
                </div>
            </div>
        );
    };

    createDataTitleExclusions = (
        title,
        data,
        makeSkuExclusionTypePK,
        makeSkuFlagFK,
        inventoryFlagFK,
        makeSkuExceptionReason,
        makeSkuFlagReason,
        tooltipReason,
        tooltipFlagReason,
        type,
        noExclusion
    ) => {
        // Prepare variables for output
        let content = null;
        let className = "col-sm-7 align-left";
        let tooltip = null;

        // Condition flags for clarity
        const isSuggested = type === "suggested";
        const isOrderable = type === "orderable";
        const isExclusionType = makeSkuExclusionTypePK != 0;
        const isExclusionTypeOrderable = makeSkuExclusionTypePK == 2 || makeSkuExclusionTypePK == 4;
        const isMakeSkuFlagOne = makeSkuFlagFK == 1;

        if (isSuggested) {
            // Suggested logic
            if (this.props.partInfo.orderable == 0) {
                content = this.props.pageText.no;
            } else if (this.props.partInfo.suggestible != 1) {
                content = this.props.pageText.no;
            } else if (isExclusionType) {
                className += " help exculsion-text";
                tooltip = `${tooltipReason} ${makeSkuExceptionReason}`;
                content = this.props.pageText.no;
            } else if (isMakeSkuFlagOne) { 
                if (inventoryFlagFK != makeSkuFlagFK) {
                    className += " help exculsion-text";
                    tooltip = `${tooltipFlagReason} ${makeSkuFlagReason}`;
                    content = this.props.pageText.no;
                } else {
                    content = this.props.pageText.yes;
                }
            } else {
                content = this.props.pageText.yes;
            }

            // Tooltip logic for suggested type
            if (this.props.partInfo.orderable == 0 || this.props.partInfo.suggestible != 1) {
                if (isExclusionType || (isMakeSkuFlagOne && inventoryFlagFK != makeSkuFlagFK)) {
                    className += " help exculsion-text";
                    tooltip = isExclusionType 
                        ? `${tooltipReason} ${makeSkuExceptionReason}`
                        : `${tooltipFlagReason} ${makeSkuFlagReason}`;
                }
            }

        } else if (isOrderable) {
            //Orderable logic
            if (this.props.partInfo.orderable != 1) {
                content = this.props.pageText.no;
            } else if (isExclusionType) {
                if (isExclusionTypeOrderable) {
                    className += " help exculsion-text";
                    tooltip = `${tooltipReason} ${makeSkuExceptionReason}`;
                    content = this.props.pageText.no;
                } else {
                    if (isMakeSkuFlagOne)
                    { 
                        if (inventoryFlagFK != makeSkuFlagFK) {
                            className += " help exculsion-text";
                            tooltip = `${tooltipFlagReason} ${makeSkuFlagReason}`;
                            content = this.props.pageText.no;
                        } else {
                            content = this.props.pageText.yes;
                        }
                    } else {
                        content = this.props.pageText.yes;
                    }
                }
            } else if (isMakeSkuFlagOne) {
                if (inventoryFlagFK != makeSkuFlagFK) {
                    className += " help exculsion-text";
                    tooltip = `${tooltipFlagReason} ${makeSkuFlagReason}`;
                    content = this.props.pageText.no;
                } else {
                    content = this.props.pageText.yes;
                }
            } else {
                content = this.props.pageText.yes;
            }

            //Tootltip
                if ((isExclusionType && isExclusionTypeOrderable) || 
                    (isMakeSkuFlagOne && inventoryFlagFK != makeSkuFlagFK)) {
                    className += " help exculsion-text";
                    tooltip = isExclusionType && isExclusionTypeOrderable 
                        ? `${tooltipReason} ${makeSkuExceptionReason}`
                        : `${tooltipFlagReason} ${makeSkuFlagReason}`;
                }

        } else {
            // Fallback for other types
            content = noExclusion === true ? this.props.pageText.yes : this.props.pageText.no;
        }

        // Return readable JSX
        return (
            <div className="row no-gutters">
                <div className="col-sm-5 align-left">
                    <p className="data-header">{title}</p>
                </div>
                <div className={className} title={tooltip}>
                    {content}
                </div>
            </div>
        );
    };

    checkDate = (date) => {
        const formatted = formatDateOnly(this.props.sessionInfo.cultureCode, date);
        return formatted !== 'Invalid Date' ? formatted : "N/A";
    }

    checkOverrideStatus = (onHold, onOverride) => {
        const { culture } = this.props;
        let overrideStatus = language[culture] ? language[culture].No : "No";
        if (onHold && onOverride) {
            overrideStatus = language[culture] ? language[culture].Both : "Both";
        }
        else if (onOverride) {
            overrideStatus = language[culture] ? language[culture].OVR : "OVR";
        }
        else if (onHold) {
            overrideStatus = language[culture] ? language[culture].Hold : "Hold";
        }
        return overrideStatus;
    }

    checkDescription(description, reqPart) {
        const fullDescription = description + reqPart;
        return fullDescription;
    }

    render() {
        const dateFormat = getDateFormatDealer(this.props.dateFormat);
        let part = this.props.partInfo;
        let forceInLocator = this.props.forceInLocator;
        let d2dDefault = this.props.defaultClickToBuyLevel.description + " (" + this.props.defaultClickToBuyLevel.sellingPercentage + "%)";
        let comment = this.props.commentEdit !== null ? this.props.commentEdit : this.props.partNote ? this.props.partNote.note : null;
        let override = this.props.overrideEdit >= 0 ? this.props.overrideEdit : this.props.inventorySkuClickToBuyLevels ? this.props.inventorySkuClickToBuyLevels.clickToBuyFK : 0;
        let clickToBuy = this.props.clickToBuy ? true : false;
        let displayD2D = this.props.makeClickToBuyOverrideLevels.length > 0 ? true : false;
        if (override > 0) {
            let level = this.props.makeClickToBuyOverrideLevels.find(m => m.makeClickToBuyPK === parseInt(override));
            if (level) {
                d2dDefault = level.description + (level.sellingPercentage > 0 ? " (" + level.sellingPercentage + "%)" : "");
            }
        }
        return (
            <>
                <div className="basic-info container-fluid">
                    <h5 className="basic-info-title title">{this.props.pageText.basicInfoTitle}<i className="material-icons" title={this.props.pageText.basicInfoToolTip}>help</i></h5>
                    <div className="basic-info-content">
                        <div className="input-group input-group-sm mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text">{this.props.pageText.basicInfoPartNotes}</span>
                            </div>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                placeholder={this.props.basicPartNotesPlace}
                                value={comment ? comment : ""}
                                onChange={(e) => this.props.onChangePartNote(e)}
                            />
                        </div>
                        <div className="row">
                            <div className="col-sm-3">
                                {this.createDataTitlePair(this.props.pageText.basicDealerCode, this.props.dealerCode)
                                }
                            </div>
                            <div className="col-sm-3">
                                {
                                    this.createDataTitlePairForPartNumber(this.props.pageText.partNumber, part.partNumber, part.makeTitle, part.active)
                                }

                            </div>
                            <div className="col-sm-3">
                                {this.createDataTitlePair(this.props.pageText.packQuantity, part.packQuantity)}
                            </div>
                            <div className="col-sm-3">
                                {this.createDataTitlePair(this.props.pageText.entryDate, this.checkDate(part.entryDate))}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-3">
                                {this.createDataTitlePair(this.props.pageText.manufacturer, part.makeTitle)}
                            </div>
                            <div className="col-sm-3">
                                {this.createDataTitlePair(this.props.pageText.perJobQuantity, part.perJobQuantity)}
                            </div>
                            <div className="col-sm-3">
                                {this.createDataTitlePair(this.props.pageText.lastReceiptDate, this.checkDate(part.lastReceiptDate))}
                            </div>
                            {this.props.userPermissions && this.props.userPermissions.includes(1) ?
                                <div className="col-sm-3">
                                    {
                                        this.createDataTitlePair(this.props.pageText.overrideHold, this.checkOverrideStatus(part.onHold, part.onOverride))

                                    }
                                    {
                                        !part.onHold && !part.onOverride ?
                                            <i className="material-icons material-override" onClick={() => this.callOverride()}>add_circle</i>
                                            : ""
                                    }
                                </div> : null
                            }
                        </div>
                        <div className="row">
                            <div className="col-sm-3">
                                {this.createDataTitlePair(this.props.pageText.description, this.checkDescription(part.description, part.reqPart), true)}
                            </div>
                            <div className="col-sm-3">
                                {this.createDataTitlePair(this.props.pageText.stockingStatus, part.stockingStatus)}
                            </div>
                            <div className="col-sm-3">
                                {this.createDataTitlePair(this.props.pageText.lastSaleDate, this.checkDate(part.lastOrderDate))}
                            </div>
                            <div className="col-sm-3">
                                {this.createDataTitleExclusions(this.props.pageText.orderable,
                                    (part.makeSkuExclusionTypePK == 2 || part.makeSkuExclusionTypePK == 4) ? this.props.pageText.no : this.props.pageText.yes,
                                    part.makeSkuExclusionTypePK, part.makeSkuFlagFK, part.inventoryFlagFK, part.makeSkuExceptionReason, this.props.pageText.tooltipFlagReason, this.props.pageText.tooltipOrderableBeforeReason, "", "orderable", (part.inventoryFlagFK != 0 && part.makeSkuFlagFK != 0) ? true : part.orderable)}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-3">
                                {this.createDataTitlePair(this.props.pageText.bin, part.bin)}
                            </div>
                            <div className="col-sm-3">
                                {this.createDataTitlePair(this.props.pageText.dealerCost, formatCurrencyAmount(part.dealerCost, this.props.sessionInfo.selected, true, true))}
                            </div>
                            <div className="col-sm-3">
                                {this.createDataTitlePair(this.props.pageText.age, part.age ? part.age : this.props.pageText.na)}
                            </div>
                            <div className="col-sm-3">
                                {this.createDataTitleExclusions(this.props.pageText.suggestible,
                                    (part.inventoryFlagFK == 0) || (part.makeSkuFlagFK == 0) || (part.makeSkuExclusionTypePK != 0) ? this.props.pageText.no : this.props.pageText.yes,
                                    part.makeSkuExclusionTypePK, part.makeSkuFlagFK, part.inventoryFlagFK, part.makeSkuExceptionReason, this.props.pageText.tooltipFlagReasonSuggestible, this.props.pageText.tooltipSuggestionsBeforeReason, "", "suggested", part.suggestible)}
                            </div>

                        </div>
                        <div className="row">

                            {displayD2D && clickToBuy ?
                                <div className="col-sm-3">
                                    {this.createDataTitlePair(this.props.pageText.dealer2DealerDefault, d2dDefault)}
                                </div>
                                : ""
                            }

                            {displayD2D && clickToBuy ?
                                <div className="col-sm-3">
                                    {this.createDataTitlePair(this.props.pageText.dealer2DealerOverride,
                                        <select className="form-control form-control-sm" onChange={(e) => this.props.onChangeOverride(e)} value={override}>
                                            <option key={0} value={0}>None</option>
                                            {this.props.makeClickToBuyOverrideLevels.map(m => {
                                                return <option key={m.makeClickToBuyPK} value={m.makeClickToBuyPK}>{m.description + (m.sellingPercentage > 0 ? " (" + m.sellingPercentage + "%)" : "")}</option>;
                                            })}
                                        </select>
                                    )}
                                </div>
                                : ""
                            }

                            <div className="col-sm-3">
                                {this.createDataTitlePair(this.props.pageText.unitOfMeasure, part.uom ? part.uom : this.props.pageText.na)}
                            </div>
                            <div className="col-sm-3">
                                {this.createDataTitlePairForReason(this.props.pageText.returnable, part.returnable ? this.props.pageText.yes : this.props.pageText.no, false, part.inventoryFlagFK, part.makeSkuFlagFK, this.props.pageText.tooltipFlagReasonReturnable)}
                            </div>
                        </div>
                        { this.props.userPermissions && this.props.userPermissions.includes(1) && parseInt(this.props.partInfo.ssOnHand) > 0 ?
                            <div className="row">
                                <div className="col-sm-3">
                                    {this.createDataTitlePair("Force Part to Show in Locator",
                                        <input type="checkbox" className="form-check-input ml-0" checked={forceInLocator} onChange={(e) => this.props.onChangeForceInLocator(e)} />
                                    )}
                                </div>
                            </div> : null}
                    </div>
                </div>
            </>
        );
    }
}